import React, {useState} from 'react';
import {Button, Card, Col, Container, Form, Image, InputGroup, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeftLong,
    faArrowsSpin,
    faCheck, faCircleExclamation,
    faClock,
    faCrown,
    faSpinner,
    faTint
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import WorkFlowInfoModal from "../../components/WorkFlowInfoModal";
import WorkFlowExecuteModal from "../../components/WorkFlowExecuteModal";
import ApiService from "../../api/ApiService";
import LocalDataService from "../../api/LocalDataService";
import SVipModal from "../../components/SVipModal";
import {toast} from "react-toastify";
import {formatBeijingTime} from "../../api/TimeService";

import './AgentInfo.css'
import FileUpload from "../../components/FileUpload";

export default function AgentInfo() {
    const {id} = useParams();
    const api = new ApiService();
    const navigate = useNavigate();
    const [workFlowInfoAddDlgShow, setWorkFlowInfoDlgShow] = React.useState(false);
    const [workFlowExecuteDlgShow, setWorkFlowExecuteDlgShow] = React.useState(false);
    const [selectedWorkflowIndex, setSelectedWorkflowIndex] = React.useState(0);
    const [selectedWorkflow, setSelectedWorkflow] = React.useState(null);
    const [agentInfo, setAgentInfo] = React.useState(null);
    const [showSVipModal, setShowSVipModal] = React.useState(false);//开通SVIP
    const [user, setUser] = useState(null);
    const [isMobile, setIsMobile] = React.useState(false);
    const [discord, setDiscord] = React.useState(1);
    const [isUseWorkflow, setIsUseWorkflow] = React.useState(false);
    const [submitStatus, setSubmitStatus] = React.useState(false);
    var isInitialized = false;
    React.useEffect(() => {
        // 添加一个引用来跟踪组件是否已经初始化
        isInitialized = false;
        
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用

        const userData = LocalDataService.load_user_data();
        if (!userData) {
            navigate('/cozeList/');
            return;
        } else {
            setUser(userData);
            const discount = userData?.vip.level > 1 ? 0.7 : userData?.vip.level > 0 ? 0.9 : 1;
            setDiscord(discount);
            
            // 只有当组件未初始化时才执行API调用
            if (!isInitialized) {
                isInitialized = true;
                api.getWorkflowInfo(id).then(res => {
                    if (res.code === 200) {
                        setAgentInfo(res.data);
                        // const flow = res.data.flows[selectedWorkflowIndex];
                        setSelectedWorkflow(res.data);
                    } else if (res.code === -4001) {
                        toast.error('请先登录');
                        navigate('/home');
                    } else {
                        toast.error(res.msg);
                    }
                })
                loadApiKeyList();
            }
        }
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const loadApiKeyList = async () => {
        const getList = await api.get_api_token_list();
        if (getList.code === 200) {
            const list = getList.data;
            const token = list[0].token;
            LocalDataService.setApiToken(token);
        }
    };

    function setWorkFlowInfoVisible(workFlowInfoAddDlgShow) {
        if (isNeedVip()) {
            return
        }
        setSelectedWorkflow(agentInfo.flows[selectedWorkflowIndex]);
        setWorkFlowInfoDlgShow(workFlowInfoAddDlgShow)
    }

    function setWorkFlowExecuteVisible(workFlowExecuteDlgShow) {
        if (isNeedVip()) {
            return
        }
        const flow = agentInfo.flows[selectedWorkflowIndex];
        if (!hasMoney(flow?.estimatedCost* discord)) {
            return;
        }
        setSelectedWorkflow(flow);
        setWorkFlowExecuteDlgShow(workFlowExecuteDlgShow)
    }

    function isNeedVip() {
        if (agentInfo?.vip > 0) {
            // 获取用户信息，检查是否是SVIP
            var user = LocalDataService.load_user_data();
            var isVipUser = user?.vip.level > 0; // 假设用户level大于等于1 VIP用户
            var isNeedUpdate = agentInfo?.vip > user?.vip.level;
            // 如果有需要SVIP的bot且用户不是SVIP
            if (!isVipUser || isNeedUpdate) {
                setShowSVipModal(true);
                return true;
            }
        }
        return false;
    }

    function hasMoney(cost) {
        var user = LocalDataService.load_user_data();
        // 优化VIP折扣计算逻辑
        if (cost > (user?.points?.perpetual + user?.points?.temp)) {
            toast.error('余额不足，请先充值');
            navigate('/vipCenter?tab=PluginsPackages')
            return false;
        } else {
            return true;
        }
    }

    const isImage = (url) => {
        if (!url) return false;
        const imageExtensions = ['\.jpg$', '\.jpeg$', '\.png$', '\.gif$'];
        const regex = new RegExp(imageExtensions.join('|'), 'i');
        return regex.test(url);
    };
    const executeTask = async (event) => {

        event.preventDefault();
        const formData = new FormData(event.target);
        setSubmitStatus(true);
        try {
            const jsonData = {};
            let hasError = false;

            // 创建一个包含所有异步操作的promise数组
            const promises = selectedWorkflow?.input.map(async (item, index) => {
                const value = formData.get(item.name);
                if (value && typeof value === 'object' && value instanceof File) {
                    if (!item.required && value.name===''){
                        jsonData[item.name] = item.defaultValue?? '';
                    }else{
                        console.log('文件类型:', value.type);
                        if (!value.type.startsWith(item.type)) {
                            toast.error(item.title + `--请上传正确格式的文件`);
                            hasError = true;
                            setSubmitStatus(false);
                            return;
                        }

                        // 处理HEIC和WebP格式图片转换为PNG
                        let fileToUpload = value;
                        const fileName = value.name.toLowerCase();
                        if (fileName.endsWith('.heic') || fileName.endsWith('.webp')) {
                            // 这里应该进行实际的格式转换
                            // 为演示目的，我们只是修改文件扩展名和类型
                            const newName = fileName.replace(/\.(heic|webp)$/i, '.png');
                            fileToUpload = new File([value], newName, { type: 'image/png' });
                        }

                        // 上传文件并等待结果
                        // const result = await api.uploadCozeFile(value, selectedWorkflow?.id);

                        // 从文件名中提取后缀
                        const fileNameForUpload = fileToUpload.name;
                        console.log('文件名:', fileNameForUpload);
                        const fileParts = fileNameForUpload.split('.');
                        const suffix = fileParts.length > 1 ? fileParts[fileParts.length - 1] : '';
                        console.log('文件后缀:', suffix);
                        const result = await api.uploadHsFile(suffix);
                        //result.data 格式 {
                        //         "method": "string",
                        //         "signedUrl": "string",
                        //         "url": "string"
                        //     }
                        //接口请求返回签名的url，上传文件时发起请求，请求方式：put； 请求地址为：signedUrl 参数；请求body为二进制文件。上传完成后，该文件在云存储的地址为url对应的地址。
                        if (result.code === 200) {
                            // 向签名URL发起PUT请求上传文件
                            try {
                                const uploadResponse = await fetch(result.data.signedUrl, {
                                    method: result.data.method || 'PUT',
                                    body: fileToUpload,
                                    headers: {
                                        'Content-Type': fileToUpload.type || 'application/octet-stream',
                                    },
                                });

                                if (!uploadResponse.ok) {
                                    toast.error(`文件上传失败: ${uploadResponse.status}`);
                                    hasError = true;
                                    setSubmitStatus(false);
                                    return;
                                }

                                // 上传成功后使用返回的URL
                                jsonData[item.name] = result.data.url;
                            } catch (uploadError) {
                                toast.error(`文件上传失败: ${uploadError.message}`);
                                hasError = true;
                                setSubmitStatus(false);
                                return;
                            }
                        } else {
                            toast.error(`获取上传地址失败: ${result.msg}`);
                            hasError = true;
                        }
                    }
                } else {
                    console.log(item.name, value)
                    if (item.hide) {
                        jsonData[item.name] = item.defaultValue || "";
                    } else {
                        // 处理switch组件的布尔值转换（on/null 转换为 true/false）
                        if (item.type === "bool") {
                            jsonData[item.name] = value === "on" || value === true;
                        } else {
                            jsonData[item.name] = value;
                        }
                    }
                }
            }) || [];

            // 等待所有异步操作完成
            await Promise.all(promises);

            // 如果有错误则不继续执行
            if (hasError) {
                setSubmitStatus(false);
                return;
            }

            console.log(jsonData)
            console.log("成功")
            const result = await api.executeWorkflow(selectedWorkflow?.id, jsonData);
            if (result.code === 200) {
                toast.success(`提交成功`);
                navigate('/WorkFlowExecuteRecordList')
            }else {
                toast.error(`执行失败: ${result.msg}`);
            }

            setSubmitStatus(false);
        } catch (error) {
            setSubmitStatus(false);
            toast.error(`执行失败: ${error.data}`);
        }
    };
    const handleSubmit = (e) => {
        if (isNeedVip()) {
            e.preventDefault(); // 阻止链接默认行为
            return;
        }
        if (!hasMoney(selectedWorkflow?.estimatedCost* discord)) {
            e.preventDefault(); // 阻止链接默认行为
            return;
        }
    }
    return (
        <>
            <Container>
                <div className={'pb-3'}>
                    <div style={{alignItems: 'start', display: 'flex',}}>
                        <button style={{
                            color: '#101217',
                            border: 'none',
                            background: '#02C8E3',
                            borderRadius: '12px',
                            padding: '6px 22px',
                            marginBottom: '10px',
                        }} onClick={() => {
                            // cozeWebSDK?.hideChatBot();
                            navigate('/cozeList')
                        }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                            智能体集合
                        </button>
                    </div>
                    <div style={{background: '#15191E', padding: '24px', borderRadius: '20px',}}>
                        {/* 左侧视频播放器 */}
                        <Row>
                            <Col lg={7}>
                                <Card style={{borderRadius: '20px', overflow: 'hidden', border: 'none'}}>
                                    <>
                                        {isImage(agentInfo?.video) ? (
                                            <img style={{
                                                width: '100%',
                                                height: 'auto',
                                                maxHeight: '700px',
                                                background: '#000',
                                                objectFit: 'contain'
                                            }} src={agentInfo?.video} alt=""/>
                                        ) : (
                                            <video autoPlay={true}
                                                   src={agentInfo?.video}
                                                   style={{
                                                       width: '100%',
                                                       height: 'auto',
                                                       maxHeight: '700px',
                                                       background: '#000',
                                                       objectFit: 'contain'
                                                   }}
                                                   controls preload="metadata"
                                                   poster={agentInfo?.cover}/>
                                        )}
                                    </>

                                </Card>

                            </Col>

                            {/* 右侧工作流列表 */}
                            <Col lg={5}>
                                <Card style={{background: '#1E222E', color: '#fff', borderRadius: '20px'}}>
                                    {!isUseWorkflow && <Card.Body>
                                        <div className={'d-flex align-items-center mb-2'}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip style={{fontSize: '12px',}}>
                                                    <div>{agentInfo?.videoDuration > 0 ?
                                                        ('预估费用￥' + (selectedWorkflow?.estimatedCost / 100 / agentInfo?.videoDuration * 5 * discord).toFixed(2) + '/5秒')
                                                        : ('单次调用预估费用:￥' + (selectedWorkflow?.estimatedCost / 100 * discord).toFixed(2))}<span
                                                        style={{
                                                            color: '#02C8E3',
                                                            fontWeight: 'bold'
                                                        }}>{+user?.vip?.level > 1 ? '(SVIP折扣后)' : user?.vip?.level > 0 ? '(VIP折扣后)' : ''}</span>
                                                    </div>
                                                    费用为扣子空间官方插件收取，实际费用上下浮动，可在智能体记录中查看实际消耗明细；</Tooltip>}
                                                trigger={["hover", "focus"]}
                                            >
                                                <span style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    background: user?.vip?.level > 1 ? "linear-gradient( 156deg, #6959BC 0%, #1C1753 100%)" : user?.vip?.level > 0 ? "linear-gradient( 156deg, #FFDE92 0%, #F99B3D 100%)" : "linear-gradient( 156deg, #C2C8CE 0%, #9AA3AB 100%)",
                                                    padding: "4px 8px",
                                                    borderTopRightRadius: "18px",
                                                    borderBottomLeftRadius: "18px",
                                                    fontSize: "small",
                                                    color: user?.vip?.level > 1 ? '#DCCEFF' : user?.vip?.level > 0 ? '#8C4900' : '#43637E',
                                                    cursor: "help",
                                                    fontWeight: 'bold',
                                                }}>
                                                    {agentInfo?.videoDuration > 0 ?
                                                        ('预估￥' + (selectedWorkflow?.estimatedCost / 100 / agentInfo?.videoDuration * 5 * discord).toFixed(2) + '/5秒')
                                                        : ('预估￥' + (selectedWorkflow?.estimatedCost / 100 * discord).toFixed(2))}
                                                </span>
                                            </OverlayTrigger>
                                            <Image src={agentInfo?.cover} width={68} height={68}
                                                   style={{
                                                       objectFit: 'cover',
                                                       objectPosition: 'center',
                                                       marginRight: '10px',
                                                       flexShrink: 0
                                                   }}
                                                   rounded={true}/>
                                            <div className={'text-start w-100'}>
                                                <h5>{agentInfo?.title}</h5>
                                                {/*<span style={{*/}
                                                {/*    color: '#697880',*/}
                                                {/*    fontSize: '14px'*/}
                                                {/*}}>{agentInfo?.content}</span>*/}
                                                <div className={'mt-1 d-flex align-items-center'}
                                                     style={{fontSize: '14px'}}>
                                                    <span className={'d-flex align-items-center'}>
                                                        <FontAwesomeIcon icon={faClock} color={'#02C8E3'}
                                                                         style={{marginRight: '4px'}}/>
                                                    更新：{formatBeijingTime(agentInfo?.created, 'YYYY-MM-DD')}
                                                    </span>

                                                </div>
                                                {/*<Card.Text className={'mt-2 d-flex justify-content-between'}>*/}
                                                {/*    <span className={'d-flex align-items-center'}>*/}
                                                {/*       <Image src={'/images/logo.svg'} width={22} height={22}*/}
                                                {/*              roundedCircle style={{marginRight: '4px'}}/>*/}
                                                {/*    作者：沸推AI*/}
                                                {/*    </span>*/}
                                                {/*   */}
                                                {/*</Card.Text>*/}
                                            </div>
                                        </div>

                                        <Card.Text className={'d-flex justify-content-between'}>
                                            <strong style={{
                                                borderLeftStyle: 'solid',
                                                borderLeftColor: '#02C8E3',
                                                borderLeftWidth: '5px',
                                                padding: '2px 8px',
                                                fontSize: '18px',
                                                color: '#fff'
                                            }}>输入参数列表
                                                {/*<span style={{*/}
                                                {/*    color: '#02C8E3',*/}
                                                {/*    marginLeft: '8px'*/}
                                                {/*}}>{agentInfo?.flows.length}</span>*/}
                                            </strong>
                                            {agentInfo?.vip > 0 && <span style={{
                                                color: '#121419',
                                                fontWeight: 'bold',
                                                background: 'linear-gradient( 156deg, #FFCA95 0%, #FF9F10 100%)',
                                                padding: '4px 12px',
                                                alignSelf: 'center',
                                                borderRadius: '20px'
                                            }}><FontAwesomeIcon icon={faCrown} color={'#FB9600'}
                                                                style={{marginRight: '4px'}}/>
                                                高级特权</span>}
                                        </Card.Text>


                                        <Form onSubmit={executeTask} style={{textAlign: 'start'}}>
                                            {selectedWorkflow?.input && selectedWorkflow?.input.map((item, index) => (
                                                <div key={index} style={{display: item.hide ? 'none' : 'block'}}>
                                                    <Form.Label htmlFor="basic-url"><span
                                                        style={{
                                                            color: '#fff',
                                                            justifyContent: 'center'
                                                        }}>{item.required && (<span style={{color: 'red'}}>*</span>)}
                                                        {item.title ? item.title : item.name}
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip
                                                                style={{fontSize: '12px'}}>{item.description}</Tooltip>}
                                                            trigger={["hover", "focus"]}>
                                                            <FontAwesomeIcon icon={faCircleExclamation}
                                                                             style={{marginLeft: '4px'}}/>
                                                        </OverlayTrigger>
                                                    </span></Form.Label>
                                                    {(item.type === "video" || item.type === "image" || item.type === "audio") ?
                                                        <FileUpload name={item.name}
                                                                    placeholder={item.description}
                                                                    accept={item.type + "/*"}
                                                                    defaultValue={item.defaultValue}
                                                                    required={item.required}/>
                                                        :
                                                        <InputGroup className="mb-3">
                                                            {(item.type === "bool")?
                                                            <Form.Check
                                                                type="switch"
                                                                id={item.name}
                                                                name={item.name}
                                                                defaultChecked={item.defaultValue==='true'}
                                                                required={item.required}
                                                            />
                                                            :(item.type === "select")?
                                                                <Form.Select
                                                                    name={item.name}
                                                                    id={item.name}
                                                                    label={item.title}
                                                                    style={{backgroundColor: '#101319',color: '#697880',borderColor: '#303B41'}}
                                                                    defaultValue={item.defaultValue}>
                                                                    {item.options.map((option, index) => (
                                                                        <option key={index} value={option.value} style={{color: '#697880',background: '#000'}}>{option.label}</option>
                                                                    ))}
                                                                </Form.Select>
                                                            :(item.name === "api_token") ?
                                                                <Form.Control id={item.name} name={item.name}
                                                                              placeholder={item.description}
                                                                              value={LocalDataService.loadApiToken()}
                                                                              readOnly
                                                                              required={item.required}/>
                                                                :
                                                                <Form.Control as="textarea" id={item.name}
                                                                              name={item.name}
                                                                              placeholder={item.description}
                                                                              type={item.type}
                                                                              defaultValue={item.defaultValue}
                                                                              required={item.required}/>
                                                            }
                                                        </InputGroup>
                                                    }
                                                    {item.name === "api_token" &&
                                                        <p style={{color: '#02C8E3'}}><FontAwesomeIcon
                                                            icon={faCheck}/> 已自动填充您的API密钥
                                                        </p>}
                                                </div>
                                            ))}
                                            <div className={'d-flex justify-content-end align-items-center'}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip style={{fontSize: '12px',}}>
                                                        <div>{agentInfo?.videoDuration > 0 ?
                                                            ('预估费用￥' + (selectedWorkflow?.estimatedCost / 100 / agentInfo?.videoDuration * 5 * discord).toFixed(2) + '/5秒')
                                                            : ('单次调用预估费用:￥' + (selectedWorkflow?.estimatedCost / 100 * discord).toFixed(2))}<span
                                                            style={{
                                                                color: '#02C8E3',
                                                                fontWeight: 'bold'
                                                            }}>{+user?.vip?.level > 1 ? '(SVIP折扣后)' : user?.vip?.level > 0 ? '(VIP折扣后)' : ''}</span>
                                                        </div>
                                                        费用为扣子空间官方插件收取，实际费用上下浮动，可在智能体记录中查看实际消耗明细；</Tooltip>}
                                                    trigger={["hover", "focus"]}
                                                >
                                                <span style={{color: '#fff', marginRight: '10px', fontSize: '14px'}}>
                                                    {agentInfo?.videoDuration > 0 ?
                                                        ('预估费用:￥' + (selectedWorkflow?.estimatedCost / 100 / agentInfo?.videoDuration * 5 * discord).toFixed(2) + '/5秒')
                                                        : ('单次调用预估费用:￥' + (selectedWorkflow?.estimatedCost / 100 * discord).toFixed(2))}
                                                    <span style={{
                                                        color: '#02C8E3',
                                                        fontWeight: 'bold'
                                                    }}>{+user?.vip?.level > 1 ? '(SVIP折扣后)' : user?.vip?.level > 0 ? '(VIP折扣后)' : ''}</span>
                                                </span>
                                                </OverlayTrigger>
                                                <Button type="submit"
                                                        onClick={(e) =>handleSubmit(e)}
                                                        disabled={submitStatus}
                                                        style={{
                                                            width: '70%',
                                                            background: 'linear-gradient(-90deg, #723BFF, #02C8E3)',
                                                            color: '#ffffff',
                                                            fontWeight: 'bold',
                                                            border: 'none',
                                                            flexShrink: 0,
                                                        }}>执行工作流
                                                    {submitStatus && <FontAwesomeIcon icon={faSpinner} spin={true}
                                                                                      className="ms-2"/>}
                                                </Button>
                                            </div>
                                        </Form>
                                    </Card.Body>}

                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
            <WorkFlowInfoModal visible={workFlowInfoAddDlgShow}
                               flowId={selectedWorkflow?.id}
                               onClose={() => setWorkFlowInfoDlgShow(false)}/>
            <WorkFlowExecuteModal visible={workFlowExecuteDlgShow}
                                  cost_money={selectedWorkflow?.estimatedCost}
                                  video_duration={selectedWorkflow?.videoDuration}
                                  flowId={selectedWorkflow?.id}
                                  input_data={selectedWorkflow?.input}
                                  onClose={() => setWorkFlowExecuteDlgShow(false)}/>
            <SVipModal visible={showSVipModal} vipLevel={agentInfo?.vip} onClose={() => setShowSVipModal(false)}/>
        </>
    );
}
